var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgDisconnectButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 20,
    rx: 10,
    fill: "#30313D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15C12.5 13.5272 10.7092 12.3333 8.50001 12.3333C6.29086 12.3333 4.5 13.5272 4.5 15M13.8334 11.6666L15.1667 10.3333M15.1667 10.3333L16.5 9M15.1667 10.3333L13.8334 9M15.1667 10.3333L16.5 11.6666M8.50001 10.3333C7.02725 10.3333 5.83334 9.13943 5.83334 7.66667C5.83334 6.19391 7.02725 5 8.50001 5C9.97277 5 11.1667 6.19391 11.1667 7.66667C11.1667 9.13943 9.97277 10.3333 8.50001 10.3333Z",
    stroke: "#E2425C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnectButton);
export default __webpack_public_path__ + "static/media/disconnect-button.4cbac2284d8aec7f163e603ac4c97bcc.svg";
export { ForwardRef as ReactComponent };